import { render, staticRenderFns } from "./chemPhoto.vue?vue&type=template&id=1aa823c2"
import script from "./chemPhoto.vue?vue&type=script&lang=js"
export * from "./chemPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa823c2')) {
      api.createRecord('1aa823c2', component.options)
    } else {
      api.reload('1aa823c2', component.options)
    }
    module.hot.accept("./chemPhoto.vue?vue&type=template&id=1aa823c2", function () {
      api.rerender('1aa823c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemPhoto.vue"
export default component.exports